import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import {
  StrapiLinkDTO,
  LinkDTO,
} from "@lib/strapi/dtos/components/shared/link.dto";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import { ImageProps } from "@lib/image";

export interface StrapiMenuItemDTO extends StrapiDynamicZoneComponentDTO {
  link: StrapiLinkDTO;
  image: StrapiMediaDTO;
}

export class MenuItemDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  link: LinkDTO;
  image: ImageProps;
}
